import Http from "./http";

export const getAllProductsInGroupsAPI = (data) => {
  return Http.post("admin/getProductByGroupId", data);
};
